import { AppRouteProps } from "@harea/component";
import React from "react";

const ParamsMyAccountContainer = React.lazy(() => import("./containers/ParamsMyAccountContainer"))

export const ParamsMyAccountRoutes: Array<AppRouteProps> = [
    {
        path: "params",
        title: "Generic.UserAccount.Parameters.title",
        element: <ParamsMyAccountContainer />
    }
]
